export default __webpack_public_path__ + "static/media/inactivity-min.9f4fa928.svg";